<script setup>
  import { nextTick, onMounted, ref } from 'vue'
  import { useEventsStore } from '@/stores/events'
  import MemberEventItem from '@/components/Member/EventItem.vue'

  const items = ref(null)

  const props = defineProps({
    items: String
  })

  onMounted(async () => {
    const store = await useEventsStore()
    const data = await store.fetchEvents(props.items)

    items.value = await data.items
  })

</script>

<template>
  <div
    v-if="items"
    class="course-events-mobile-wrapper"
  >
    <MemberEventItem
      v-for="(item, index) in items"
      :key="index"
      :item="item"
    />
  </div>
</template>


<style lang="scss" scoped>

</style>
